import api from './api'
import type { RaceState } from '../types/index'

export const raceService = {
  async getRaceState(): Promise<RaceState> {
    const response = await api.get('/race/state')
    return response.data
  },

  async updateRaceState(data: Partial<RaceState>): Promise<RaceState> {
    const response = await api.put('/race/state', data)
    return response.data
  },

  async resetRace(): Promise<RaceState> {
    const response = await api.post('/race/reset')
    return response.data
  },
}
